import { CheckboxComponent } from './checkbox.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent],
  imports: [
    IonicModule,
    CommonModule,
  ]
})
export class CheckboxModule { }
